// Запись сессий OpenReplay на 1% сессий браузера: жребий бросается один раз за сессию и хранится
// в sessionStorage, трекер грузится отдельным чанком только при попадании. Гейтов по окружению нет —
// тестовые стенды тоже пишут.
// @openreplay/tracker закреплён на 17.x: 18+ шлёт заголовок datatype, который CORS ingest
// openreplay.multitool.cloud не разрешает, и порции записи /v1/web/i блокируются браузером.
const KEY = 'or_sampled';
const SAMPLE_RATE = 0.01;
const PROJECT_KEY = '7ndkVVLxkqBQ0sw1VFTH';
const INGEST_POINT = 'https://openreplay.multitool.cloud/ingest';

export function initOpenReplay() {
  let s;
  try { s = sessionStorage.getItem(KEY); } catch (e) {}
  if (s !== '0' && s !== '1') {
    s = Math.random() < SAMPLE_RATE ? '1' : '0';
    try { sessionStorage.setItem(KEY, s); } catch (e) {}
  }
  if (s !== '1') return;
  import(/* webpackChunkName: "openreplay" */ '@openreplay/tracker')
    .then(({ tracker }) => {
      tracker.configure({
        projectKey: PROJECT_KEY,
        ingestPoint: INGEST_POINT,
        // Трекер по умолчанию не стартует вне https (localhost, http-стенды)
        __DISABLE_SECURE_MODE: location.hostname === 'localhost' || location.protocol !== 'https:',
        inlineCss: 3,
      });
      tracker.setUserID('savefrom_co_id_user_id');
      return tracker.start();
    })
    .catch(() => {});
}
